// "How did you hear about us?" — the only visibility into acquisition that
// carries no UTM: camps, concierge outreach, coach referral, word of mouth.
//
// Values are stable storage keys and must never be renamed; labels may change
// freely. Add new options at the end, before `other`.
export const HEARD_ABOUT_OPTIONS = [
  { value: 'camp', label: 'At a ProZpects camp or event' },
  { value: 'coach', label: 'From a coach' },
  { value: 'friend_family', label: 'Friend or family' },
  { value: 'teammate', label: 'A teammate' },
  { value: 'social', label: 'Social media' },
  { value: 'search', label: 'Google or another search engine' },
  { value: 'ad', label: 'An online ad' },
  { value: 'school', label: 'My school' },
  { value: 'other', label: 'Somewhere else' },
];
